import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import uniqueId from 'lodash/uniqueId'
import { withChart } from '../../../../composables'
import TemperatureLineChart from '../../../../charts/temperature-line-chart'
import { selectCurrentMarketIndexHistoryByMonth } from '../../../../store/selectors/marketRecord'

export const TemperatureChartContainer = compose(
  connect(state => {
    const mountId = uniqueId()
    const monthData = selectCurrentMarketIndexHistoryByMonth(state)

    if (!monthData) {
      return {
        showChart: false,
      }
    }

    const transformedValueLineChartValuations = Object.values(monthData).map(
      (data, i) => ({
        id: `Temp_${mountId}_Index_${i}`,
        date: new Date(`${data.month}-02`),
        valuation: data.value,
      })
    )

    const transformedValueLineChartSegments = {
      segments: [
        {
          count: transformedValueLineChartValuations.length,
          valuations: transformedValueLineChartValuations,
        },
      ],
    }

    return {
      data: transformedValueLineChartSegments,
      showChart: true,
    }
  }),
  branch(({ showChart }) => !showChart, renderNothing),
  withChart(TemperatureLineChart)
)

export default TemperatureChartContainer
